import * as styles from './ReservationDetail.module.scss'

import { ColoredTextProps, Text } from '../../basics'

export const ItemText: React.FC<ColoredTextProps> = (props) => (
  <div className={styles.spacer}>
    <Text {...props} size={14} />
  </div>
)
